import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  ProvetDiagnosticsScope,
  ProvetDiagnosticsSnapshot,
} from '../../domain/models/provet-diagnostics.model';
import { IProvetDiagnosticsRepository } from '../../domain/repositories/provet-diagnostics.repository';
import { ProvetDiagnosticsRemoteDatasource } from '../datasources/remote/provet-diagnostics.remote-datasource';
import { ProvetDiagnosticsMapper } from '../mappers/provet-diagnostics.mapper';

@Injectable()
export class ProvetDiagnosticsRepositoryImpl implements IProvetDiagnosticsRepository {
  private readonly datasource = inject(ProvetDiagnosticsRemoteDatasource);
  private readonly mapper = inject(ProvetDiagnosticsMapper);

  public getSnapshot(
    since: number | null,
    scope: ProvetDiagnosticsScope,
  ): Observable<ProvetDiagnosticsSnapshot> {
    return this.datasource
      .fetchSnapshot(since, scope)
      .pipe(map((dto) => this.mapper.toDomain(dto)));
  }

  public resetSession(): Observable<void> {
    return this.datasource.reset();
  }
}
